﻿import $ from 'jquery';

$(document).on('mousedown.rustig.showpassword', '[data-showpassword]', function (e: JQueryEventObject) {
  $(this).prev('input[type="password"]')
         .attr("type", "text")
         .attr("data-showpassword-active", "on");
  }).on('mouseup.rustig.showpassword', function (e: JQueryEventObject) {
    $('[data-showpassword-active]')
         .attr("type", "password")
         .removeAttr("data-showpassword-active");
});